import React from 'react';
import AboutSingleCounter from '../../../components/AboutSingleCounter/AboutSingleCounter';

const AboutCounter = () => {
   return (
      <>
         <section className="counter-wraper pt-120 pb-90 gray-bg">
            <div className="container">
               <div className="row">

                  <AboutSingleCounter icon="1" counter="458" title="Countrywide Clients" />
                  <AboutSingleCounter icon="2" counter="118" title="Radiologists" />
                 
               </div>
            </div>
         </section>
      </>
   );
};

export default AboutCounter;